import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import { CountryProvider } from './context/CountryContext';

const baseTheme = createTheme();

const theme = createTheme({
    palette: {
        primary: {
            main: '#4e46e5',
        },
        secondary: {
            main: '#6366f1',
        },
        background: {
            default: '#f8fafc',
            paper: '#ffffff',
        },
        text: {
            primary: '#0f172a',
            secondary: '#475569',
        },
    },
    typography: {
        fontFamily:
            '"SF Pro Display", "Inter", "system-ui", "-apple-system", "Segoe UI", sans-serif',
        h4: {
            fontWeight: 700,
        },
        h6: {
            fontWeight: 600,
        },
    },
    shadows: baseTheme.shadows
        .map((shadow) =>
            shadow.replace(/rgba\(0,0,0,([^)]+)\)/g, 'rgba(78, 70, 229, $1)')
        ) as typeof baseTheme.shadows,
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    fontWeight: 600,
                },
            },
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    border: 'none',
                    borderRadius: 6,
                    backgroundColor: 'rgba(15, 23, 42, 0.85)',
                },
                arrow: {
                    color: 'rgba(15, 23, 42, 0.85)',
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: 16,
                    boxShadow: '0 6px 16px rgba(78, 70, 229, 0.18)',
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    borderRadius: 16,
                },
            },
        },
        MuiTable: {
            styleOverrides: {
                root: {
                    tableLayout: 'fixed',
                    width: '100%',
                },
            },
        },
    },
});

const AnalyticsTracker: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.gtag !== 'function') {
      return;
    }

    window.gtag('event', 'page_view', {
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location.pathname, location.search]);

  return null;
};

const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <CountryProvider>
        <Router>
          <AnalyticsTracker />
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/:section" element={<Dashboard />} />
            <Route path="/company/:companyId" element={<Dashboard />} />
            <Route path="/industry/:industrySlug" element={<Dashboard />} />
          </Routes>
        </Router>
      </CountryProvider>
    </ThemeProvider>
  );
};

export default App;
